export const subcategoryMap = {
  Men: ['T-Shirts', 'Shirts', 'Trousers', 'Jeans','Other'],
  Women: ['Dresses', 'Skirts', 'Ethnic Wear', 'Tops','Other'],
  Kids: ['T-Shirts', 'Shorts', 'Onesies','Jeans','Other'],
  Watches:['Kids','Men','Women']
};
